<template>
    <RoundButton
        :icon="appStore.platform === 'ios' ? 'apple' : 'android-store'"
        :interfaceTarget="`mobile-footer-install-${appStore.platform}-button`"
        :label="$tr('installAppButton.app')"
        @click="goToApp"
    />
</template>

<script setup lang="ts">
import { CREATIVE_IDS, useGoToApp } from '@/composables/use-go-to-app'
import { useAppStore } from '@/store/app-store'

import RoundButton from './RoundButton.vue'

const appStore = useAppStore()
const { goToApp } = useGoToApp(CREATIVE_IDS.UNDER_GAME_ICON)
</script>
